import { useState } from "react";

export const useAppModes = () => {
  const [focusSource, setFocusSource] = useState(null);
  const [isMostVisitedMode, setIsMostVisitedMode] = useState(false);
  const [isSavedMode, setIsSavedMode] = useState(false);
  const [savedFilter, setSavedFilter] = useState("all");

  return {
    focusSource,
    setFocusSource,
    isMostVisitedMode,
    setIsMostVisitedMode,
    isSavedMode,
    setIsSavedMode,
    savedFilter,
    setSavedFilter,
  };
};
